import { DateRange } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';
import { DatePickerMode, DateTimeRange, TimePeriodUnit } from '../types';

export function getDateTimeRange(
  dateRange: DateRange<Dayjs | null>,
  datePickerMode: DatePickerMode,
): DateTimeRange {
  const [from, to] = dateRange;

  if ('last' === datePickerMode) {
    return {
      type: 'last',
      value: from && to ? to.diff(from, TimePeriodUnit.Day) : 0,
      unit: TimePeriodUnit.Day,
    };
  }

  if ('since' === datePickerMode) {
    return {
      type: 'since',
      startAfter: from,
    };
  }

  return {
    type: 'absolute',
    startAfter: from,
    endBefore: to,
  };
}
